import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '@/environments/environment';
import { APP_ROUTES } from '@/routes/routes.type';
import { AnalyticsConsentService } from '@/services/analytics-consent/analytics-consent.service';
import { InfoPagesService } from '@/services/info-pages/info-pages.service';

@Component({
  selector: 'app-analytics-consent-banner',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './analytics-consent-banner.component.html',
})
export class AnalyticsConsentBannerComponent {
  readonly consent = inject(AnalyticsConsentService);
  private readonly infoPages = inject(InfoPagesService);

  readonly infoPageRoute = APP_ROUTES.INFO_PAGE.split('/:')[0];

  readonly privacyPolicyLink = computed(() => {
    const slug = environment.metrika.privacyPolicySlug;
    if (!slug) {
      return null;
    }
    for (const group of this.infoPages.groups()) {
      if (group.pages?.some((page) => page.slug === slug)) {
        return ['/' + this.infoPageRoute, slug] as const;
      }
    }
    return null;
  });

  constructor() {
    if (environment.metrika.privacyPolicySlug) {
      void this.infoPages.loadGroups();
    }
  }

  accept(): void {
    this.consent.grant();
  }

  decline(): void {
    this.consent.deny();
  }
}
